import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { appConfig } from './app.config';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class ApiService {

  constructor(private http: Http) { }

  getData(url: string): Promise<any[]> {
    let apiUrl = `${appConfig.apiUrl}/${url}`;
    // let dummyUrl = '/assets/data/' + url + '.json';
    return this.http.get(apiUrl)
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/app/api.service.ts